import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";

import "./landing.less";

import { IMG, CASE_BG, GENERATED_PORTFOLIO_IMGS, PRIVATE_SPHERE_IMGS, SCROLL_BRAND_IMAGES } from "../shared/image_assets";
import { linkData } from "../../official_website/data";
import { protocol } from "@util/enum";
import { getCookie, getUrl, identifyDevicePlatform, downloadFile } from "@util/utils";
import { queryUserByToken } from "@api/user";
import { navigateToPrivateDomain } from "../shared/privateDomainNav";
import { detectDevice } from "../shared/detectDevice";
import { QRCodeCanvas } from "qrcode.react";
import ReactPlayer from "react-player";
import Iconfont from "@components/iconfont/iconfont";
import { OverlayScrollbars } from "overlayscrollbars";
import "overlayscrollbars/overlayscrollbars.css";
import PricePage from "./price/PricePage";
import NewsPage from "./news/NewsPage";
import NewsDetail from "./news/NewsDetail";
import useWebsiteNavigation from "../shared/useWebsiteNavigation";
import useNewsEntryVisible from "../shared/useNewsEntryVisible";
import { scrollPageToTop } from "../shared/scrollTop";

/** 统一别名：JSX 中只引用这些点位的资源 */
const imgSolution1 = IMG.solution1;
const imgSolution2 = IMG.solution2;
const imgHeroScreen = IMG.heroScreen;
const imgHeroCard1 = IMG.heroCard1;
const imgHeroCard2 = IMG.heroCard2;
const imgHeroCard3 = IMG.heroCard3;
const imgHeroCard4 = IMG.heroCard4;
const imgCreateWeb = IMG.createWeb;
const imgDemoCursor = IMG.demoCursor; // 本地 shubiao.svg
const imgMiniProgramBg = IMG.miniProgramBg;
const imgXiaochengxu = IMG.xiaochengxu;
const imgBujueLogo = IMG.bujueLogo;
const imgBujueLogoWhite = IMG.bujueLogoWhite;

/** Webpack：`import`/url-loader 可能为 string、`{ default: string }` 或其它形态 */
function resolveImportedAsset(imported) {
  if (imported == null) return "";
  if (typeof imported === "string") return imported;
  if (typeof imported === "number") return String(imported);
  if (typeof imported === "object") {
    if (typeof imported.src === "string") return imported.src;
    const d = imported.default;
    if (typeof d === "string") return d;
    if (typeof d === "number") return String(d);
    if (d && typeof d === "object" && typeof d.src === "string") return d.src;
  }
  return "";
}

/** url-loader 可能导出 default；内联 url() 建议加引号 */
function bgImageStyle(imported) {
  const u = resolveImportedAsset(imported);
  return u ? { backgroundImage: `url("${u}")` } : {};
}

function assetUrl(imported) {
  return resolveImportedAsset(imported);
}

const GOOGLE_FONTS_CSS =
  "https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@300;400;500;700;800&family=Noto+Serif+SC:wght@600;700&display=swap";

// 应用场景演示视频（与下方 solution-card 顺序对应）：
// [0] 设计师/设计公司/全案公司  [1] 组织机构/学会/协会  [2] 材料品牌/经销商/材料集合商
const SOLUTION_VIDEOS = [
  "https://bujue-static-cdn.bujue.art/%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/1.%E4%B8%8D%E8%A7%89%EF%BC%9A%E8%AE%BE%E8%AE%A1%E5%B8%88%E5%BA%94%E7%94%A8%E5%9C%BA%E6%99%AF%E6%BC%94%E7%A4%BA.mp4",
  "https://bujue-static-cdn.bujue.art/%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/3.%E4%B8%8D%E8%A7%89%EF%BC%9A%E7%BB%84%E7%BB%87%E6%9C%BA%E6%9E%84%E5%BA%94%E7%94%A8%E5%9C%BA%E6%99%AF%E6%BC%94%E7%A4%BA.mp4",
  "https://bujue-static-cdn.bujue.art/%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/2.%E4%B8%8D%E8%A7%89%EF%BC%9A%E8%B5%84%E6%9D%90%E5%95%86%E5%BA%94%E7%94%A8%E5%9C%BA%E6%99%AF%E6%BC%94%E7%A4%BA.mp4",
];

/** 私域伙伴圈两张稿：根据滚动位置切换，>=2 视为已结束 */
const PRIVATE_SPHERE_MAX_STEP = 2;
/** 与 landing.less `--pf-slide0-half`（秒）一致：光标单程时长；往返 demo 周期为其 2 倍 */
const PF_SLIDE0_HALF_MS = 1000;
/** 操作说明：现网「不觉 SAAS 私域」帮助页（tabIndex=3） */
const OFFICIAL_SITE_INSTRUCTIONS_URL =
  "https://bujue.art/international.html#/share_page?clientId=66e1042ce932c875f8884314&tabIndex=3";
/** 关于我们：直接外链至不觉国际站 share_page tab=1 */
const OFFICIAL_SITE_ABOUT_US_URL =
  "https://bujue.at.bujue.art/international.html#/share_page?clientId=66e1042ce932c875f8884314&tabIndex=1";
/** 下载介绍：不觉中文介绍 PDF，直接下载，不再弹出 APP 下载二维码 */
const OFFICIAL_SITE_INTRO_PDF_URL =
  "https://bujue-static-cdn.bujue.art/%E5%AE%98%E7%BD%91%E8%B5%84%E6%BA%90/%E4%B8%8D%E8%A7%89%20bujue.art%20%E4%B8%AD%E6%96%87%E4%BB%8B%E7%BB%8D.pdf";

function caseSlideClass(index, active, total) {
  const diff = (index - active + total) % total;
  if (diff === 0) return "case-slide center";
  if (diff === 1) return "case-slide right";
  if (diff === total - 1) return "case-slide left";
  return "case-slide hidden";
}

/**
 * 后台预览：正文统一取管理端详情（/api/admin/news/detail，已发布 / 草稿都走这里）。
 * 预览不请求公开详情；当前后端未提供管理端推荐接口，预览也不请求推荐。
 */
function usePreviewArticle(id) {
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(Boolean(id));
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!id) {
      setArticle(null);
      setLoading(false);
      setError(false);
      return undefined;
    }

    let cancelled = false;
    setArticle(null);
    setLoading(true);
    setError(false);

    fetch(`/api/admin/news/detail?id=${encodeURIComponent(id)}`, {
      method: "GET",
      credentials: "same-origin",
      headers: { "X-Requested-With": "XMLHttpRequest" },
    })
      .then((response) => response.json())
      .then((data) => {
        if (cancelled) return;
        if (data && data.success) setArticle(data.result || null);
        else setError(true);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  return { article, loading, error };
}

export default function App({
  previewMode = false,
  previewNewsId = null,
  onPreviewClose,
} = {}) {
  const rootRef = useRef(null);
  const scaleRef = useRef(null);
  const navRef = useRef(null);
  const caseStageRef = useRef(null);
  const generatedPortfolioRef = useRef(null);
  const privateSphereRef = useRef(null);
  const miniProgramMediaRef = useRef(null);
  const miniProgramStageRef = useRef(0);
  const genStepRef = useRef(0);
  const psStepRef = useRef(0);
  const [caseActive, setCaseActive] = useState(0);
  const [contactVisible, setContactVisible] = useState(false);
  /** 当前展开的 Footer 社媒二维码 index（null 表示全部收起）；pad 端用点击切换 */
  const [openSocialIdx, setOpenSocialIdx] = useState(null);
  useEffect(() => {
    if (openSocialIdx === null) return;
    const onDocClick = (e) => {
      if (!e.target.closest(".social-item")) setOpenSocialIdx(null);
    };
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, [openSocialIdx]);
  const [appModalVisible, setAppModalVisible] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  /** 弹窗内 ReactPlayer 是否已开始播放：未开始时用首帧 <video> 占位作封面 */
  const [videoReady, setVideoReady] = useState(false);
  /** 每次打开新视频都重置封面，避免复用上一个视频的 ready 状态 */
  useEffect(() => {
    if (videoUrl) setVideoReady(false);
  }, [videoUrl]);
  const [genStep, setGenStep] = useState(0);
  const [psStep, setPsStep] = useState(0);
  const [portfolioClickPulse, setPortfolioClickPulse] = useState(false);
  const portfolioClickBusyRef = useRef(false);
  const [privateSpherePulse, setPrivateSpherePulse] = useState(false);
  const privateSphereClickBusyRef = useRef(false);
  /** 小程序模块：0 第一视觉 / 1 第二视觉（仅用于 bg-size 等不可插值属性二态切换；
   *  细粒度位置/不透明度由 CSS var --mp-progress 直接驱动） */
  const [miniProgramStage, setMiniProgramStage] = useState(0);
  /** 须由 React 驱动 `reveal in`：该块 className 会随 stage 重算，否则会覆盖 IO 写入的 `in` 致整块 opacity:0 */
  const [miniProgramRevealIn, setMiniProgramRevealIn] = useState(false);
  /** 当前视图：landing（首页全部 section）/ price（价格页）/ news（资讯页） */
  const { view, newsDetailId, newsDetailTitle, navigate } = useWebsiteNavigation({
    previewMode,
    previewNewsId,
  });
  /** 顶部「资讯」入口：分类接口有数据才展示，避免无资讯时露出空入口 */
  const hasNewsCategories = useNewsEntryVisible(!previewMode);
  const newsEntryVisible = previewMode || hasNewsCategories;
  /** 预览正文一律取管理端详情，与资讯状态无关；已发布同样走管理端 */
  const previewDetail = usePreviewArticle(previewMode ? newsDetailId : null);

  /** 用 overlayscrollbars 接管页面滚动条 —— 真悬浮、不占布局空间；预览模式同样接管，保证与正式页一致 */
  useEffect(() => {
    const osInstance = OverlayScrollbars(document.body, {
      scrollbars: {
        theme: "os-theme-dark",
        autoHide: "scroll",
        autoHideDelay: 600,
      },
    });
    return () => {
      if (osInstance && typeof osInstance.destroy === "function") {
        osInstance.destroy();
      }
    };
  }, []);

  const handlePortfolioPulseEnd = useCallback((e) => {
    const raw = e?.animationName ?? e?.nativeEvent?.animationName ?? "";
    const name =
      typeof raw === "string" ? raw.toLowerCase() : String(raw).toLowerCase();
    if (!name.includes("generated-portfolio-click-ripple")) return;
    setPortfolioClickPulse(false);
    portfolioClickBusyRef.current = false;
  }, []);

  const handlePortfolioEndClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (portfolioClickBusyRef.current) return;
    portfolioClickBusyRef.current = true;
    setPortfolioClickPulse(true);
  }, []);

  const handlePrivateSpherePulseEnd = useCallback((e) => {
    const raw = e?.animationName ?? e?.nativeEvent?.animationName ?? "";
    const name =
      typeof raw === "string" ? raw.toLowerCase() : String(raw).toLowerCase();
    if (!name.includes("generated-portfolio-click-ripple")) return;
    setPrivateSpherePulse(false);
    privateSphereClickBusyRef.current = false;
  }, []);

  const handlePrivateSphereHitClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (privateSphereClickBusyRef.current) return;
    privateSphereClickBusyRef.current = true;
    setPrivateSpherePulse(true);
  }, []);

  /** 离开带交互幻灯时复位涟漪状态 */
  useEffect(() => {
    const active = genStep >= 3 ? 2 : genStep;
    if (active !== 0 && active !== 1) {
      setPortfolioClickPulse(false);
      portfolioClickBusyRef.current = false;
    }
  }, [genStep]);

  /** 作品集 slide0/slide1：光标单次移动到终点停留 */
  useEffect(() => {
    const active = genStep >= 3 ? 2 : genStep;
    if (active !== 0 && active !== 1) return undefined;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (mq.matches) return undefined;

    setPortfolioClickPulse(false);
    portfolioClickBusyRef.current = false;

    const timeoutId = window.setTimeout(() => {
      portfolioClickBusyRef.current = true;
      setPortfolioClickPulse(true);
    }, active === 0 ? PF_SLIDE0_HALF_MS : 0);

    return () => {
      window.clearTimeout(timeoutId);
      portfolioClickBusyRef.current = false;
      setPortfolioClickPulse(false);
    };
  }, [genStep]);

  /** 私域首张：光标单次移动到终点停留 */
  useEffect(() => {
    if (psStep !== 0) return undefined;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (mq.matches) return undefined;

    setPrivateSpherePulse(false);
    privateSphereClickBusyRef.current = false;

    const timeoutId = window.setTimeout(() => {
      privateSphereClickBusyRef.current = true;
      setPrivateSpherePulse(true);
    }, PF_SLIDE0_HALF_MS);

    return () => {
      window.clearTimeout(timeoutId);
      privateSphereClickBusyRef.current = false;
      setPrivateSpherePulse(false);
    };
  }, [psStep]);

  /** 私域离开首张时复位涟漪（slide1 无光晕交互） */
  useEffect(() => {
    if (psStep === 0) return undefined;
    setPrivateSpherePulse(false);
    privateSphereClickBusyRef.current = false;
    return undefined;
  }, [psStep]);

  useEffect(() => {
    genStepRef.current = genStep;
  }, [genStep]);
  useEffect(() => {
    psStepRef.current = psStep;
  }, [psStep]);
  useEffect(() => {
    document.title = "不觉 — 0 代码搭建品牌网站 · 私域交易工具";
    const id = "official-website-new-gfonts";
    if (document.getElementById(id)) return;
    const google = document.createElement("link");
    google.rel = "preconnect";
    google.href = "https://fonts.googleapis.com";
    document.head.appendChild(google);
    const gstatic = document.createElement("link");
    gstatic.rel = "preconnect";
    gstatic.href = "https://fonts.gstatic.com";
    gstatic.crossOrigin = "";
    document.head.appendChild(gstatic);
    const sheet = document.createElement("link");
    sheet.id = id;
    sheet.rel = "stylesheet";
    sheet.href = GOOGLE_FONTS_CSS;
    document.head.appendChild(sheet);
  }, []);

  useEffect(() => {
    if (view !== "landing") return undefined;
    const root = rootRef.current;
    if (!root) return undefined;
    const els = root.querySelectorAll(
      ".reveal:not(.service-media--mini-program)"
    );
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [view]);

  /** 进入 landing 时同步重置小程序 reveal state 到 baseline。
   *  用 useLayoutEffect 保证在浏览器 paint 之前就把 in 去掉，
   *  避免上一轮残留的 true 让首帧直接是终态、跳过 transition */
  useLayoutEffect(() => {
    if (view === "landing") {
      setMiniProgramRevealIn(false);
    }
  }, [view]);

  /** 小程序区块：单独观察并写入 state，避免与动态 className 冲突（见 miniProgramRevealIn 注释） */
  useEffect(() => {
    if (view !== "landing") return undefined;
    const el = miniProgramMediaRef.current;
    if (!el) return undefined;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setMiniProgramRevealIn(true);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [view]);

  useEffect(() => {
    if (view !== "landing") return undefined;
    const root = rootRef.current;
    if (!root) return undefined;
    const wadWrap = root.querySelector(".service-create-web");
    if (!wadWrap) return undefined;
    const ratioOk = (entry) => entry.intersectionRatio >= 0.65;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          wadWrap.classList.toggle(
            "service-create-web--visible",
            ratioOk(entry)
          );
        });
      },
      {
        /* 整块媒体区需约一半出现在视口内才播；rootMargin 收小可视区域，避免刚露头就触发 */
        threshold: Array.from({ length: 21 }, (_, i) => i / 20),
        rootMargin: "-10% 0px -20% 0px",
      }
    );
    io.observe(wadWrap);
    return () => io.disconnect();
  }, [view]);

  /** 作品集 / 私域伙伴圈：跟随页面正常滚动位置切换图片，不拦截滚轮。
   *  以媒体区中心 midY 在视口中的位置为进度：start = vh*0.85 (p=0) → end = vh*0.15 (p=1)，
   *  作品集 3 张 + 末态 = 4 段；伙伴圈 2 张 + 末态 = 3 段。 */
  useEffect(() => {
    let raf = 0;

    const progressOf = (el) => {
      if (!el) return -1;
      const r = el.getBoundingClientRect();
      /* 2K/4K 兼容：vh 上限锁 1080，避免高分辨率屏 vh 过大、midY 同等滚动距离对应的进度跳得更快导致动画提前结束 */
      const vh = Math.min(window.innerHeight || 1, 1080);
      const midY = (r.top + r.bottom) / 2;
      const start = vh * 0.75;
      const end = vh * 0.70;
      const raw = (start - midY) / (start - end);
      return raw < 0 ? 0 : raw > 1 ? 1 : raw;
    };

    const evaluate = () => {
      /* 作品集进度：根据 media 的 midY 在视口中位置算 0..1
       * startW 大 → 越早开始（section 一冒头 cursor 就动）；
       * 区间越宽，每次滚轮的 pp 增量越小 */
      const gpRaw = (() => {
        const el = generatedPortfolioRef.current;
        if (!el) return -1;
        const r = el.getBoundingClientRect();
        /* 2K/4K 兼容：vh 上限锁 1080，避免高分辨率屏 vh 过大、midY 同等滚动距离对应的进度跳得更快导致动画提前结束 */
      const vh = Math.min(window.innerHeight || 1, 1080);
        const midY = (r.top + r.bottom) / 2;
        const startW = vh * 1.15;
        const endW = vh * 0.55;
        const raw = (startW - midY) / (startW - endW);
        return raw < 0 ? 0 : raw > 1 ? 1 : raw;
      })();
      if (gpRaw >= 0) {
        /* 三阶段：
         *  [0, GP_P1_END]    image 1：光标 start → end（前向），到端点后 halo 淡入
         *  [GP_P1_END, GP_P2_END]   image 2：光标 end → start（反向），到端点后 halo 淡入
         *  [GP_P2_END, 1]    image 3：静态末态（无光标）
         */
        const GP_P1_END = 0.45;
        const GP_P2_END = 0.85;
        const CURSOR_LOCAL_END = 0.55;  /* 阶段内 cursor 走完的位置 */
        const HALO_LOCAL_FULL = 0.75;   /* 阶段内 halo 全显的位置；之后 halo 稳定显示直到切图 */
        let nextStep;
        let cursorProgress;
        let haloProgress;
        if (gpRaw < GP_P1_END) {
          nextStep = 0;
          const local = gpRaw / GP_P1_END;
          cursorProgress = Math.min(1, local / CURSOR_LOCAL_END);
          haloProgress = Math.max(
            0,
            Math.min(
              1,
              (local - CURSOR_LOCAL_END) / (HALO_LOCAL_FULL - CURSOR_LOCAL_END)
            )
          );
        } else if (gpRaw < GP_P2_END) {
          nextStep = 1;
          const local = (gpRaw - GP_P1_END) / (GP_P2_END - GP_P1_END);
          cursorProgress = Math.min(1, local / CURSOR_LOCAL_END);
          haloProgress = Math.max(
            0,
            Math.min(
              1,
              (local - CURSOR_LOCAL_END) / (HALO_LOCAL_FULL - CURSOR_LOCAL_END)
            )
          );
        } else {
          nextStep = 2;
          cursorProgress = 1;
          haloProgress = 1;
        }
        if (generatedPortfolioRef.current) {
          generatedPortfolioRef.current.style.setProperty(
            "--gp-cursor-progress",
            cursorProgress.toFixed(3)
          );
          generatedPortfolioRef.current.style.setProperty(
            "--gp-halo-progress",
            haloProgress.toFixed(3)
          );
        }
        if (nextStep !== genStepRef.current) {
          genStepRef.current = nextStep;
          setGenStep(nextStep);
        }
      }
      /* 私域伙伴圈用更宽的进度区间 —— 每次滚轮 pp 增量更小，光标位移更细碎 */
      const psWideProgress = (() => {
        const el = privateSphereRef.current;
        if (!el) return -1;
        const r = el.getBoundingClientRect();
        const vh = window.innerHeight || 1;
        const midY = (r.top + r.bottom) / 2;
        const startW = vh * 0.85;
        const endW = vh * 0.55;
        const raw = (startW - midY) / (startW - endW);
        return raw < 0 ? 0 : raw > 1 ? 1 : raw;
      })();
      const pp = psWideProgress;
      if (pp >= 0) {
        /* 三段：
         * [0, PS_CURSOR_END]  光标平滑滑到终点
         * (PS_CURSOR_END, PS_SWITCH)  光标停留 + 光圈淡入显示
         * [PS_SWITCH, 1]  切到第二张图（静态光标）
         */
        const PS_CURSOR_END = 0.45;
        const PS_HALO_FULL = 0.6;
        const PS_SWITCH = 0.95;
        const cursorProgress = Math.min(1, pp / PS_CURSOR_END);
        const haloProgress = Math.min(
          1,
          Math.max(0, (pp - PS_CURSOR_END) / (PS_HALO_FULL - PS_CURSOR_END))
        );
        if (privateSphereRef.current) {
          privateSphereRef.current.style.setProperty(
            "--ps-cursor-progress",
            cursorProgress.toFixed(3)
          );
          privateSphereRef.current.style.setProperty(
            "--ps-halo-progress",
            haloProgress.toFixed(3)
          );
        }
        const next = pp >= PS_SWITCH ? PRIVATE_SPHERE_MAX_STEP : 0;
        if (next !== psStepRef.current) {
          psStepRef.current = next;
          setPsStep(next);
        }
      }
    };

    const onScroll = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(() => {
        raf = 0;
        evaluate();
      });
    };

    evaluate();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (raf) window.cancelAnimationFrame(raf);
    };
  }, []);

  useEffect(() => {
    miniProgramStageRef.current = miniProgramStage;
  }, [miniProgramStage]);

  /** 小程序：滚动驱动连续插值 —— midY 从 vh*0.6 → vh*0.4 之间，progress 0→1。
   *  CSS 用 --mp-progress 直接驱动 .phone-device 的 translateY 与 mock 的不透明度，
   *  实现「下滚平滑出来 / 上滚平滑回去」。stage 仅作背景 contain↔cover 等不可插值
   *  属性的二态切换（p>0.5 视为 stage=1）。
   *  依赖 [view]：view 切回 landing 时重新捕获新挂载的 ref，避免闭包指向已卸载节点 */
  useEffect(() => {
    if (view !== "landing") return undefined;
    const el = miniProgramMediaRef.current;
    if (!el) return undefined;
    let raf = 0;

    const evaluateScroll = () => {
      const r = el.getBoundingClientRect();
      const vh = window.innerHeight || 1;
      const midY = (r.top + r.bottom) / 2;
      const start = vh * 0.68;  /* progress = 0 — section 中心刚入视口 */
      const end = vh * 0.58;   /* progress = 1 — section 中心到达视口正中 */
      const raw = (start - midY) / (start - end);
      const p = raw < 0 ? 0 : raw > 1 ? 1 : raw;
      el.style.setProperty("--mp-progress", p.toFixed(3));
      const nextStage = p > 0.5 ? 1 : 0;
      if (miniProgramStageRef.current !== nextStage) {
        miniProgramStageRef.current = nextStage;
        setMiniProgramStage(nextStage);
      }
    };

    const onScroll = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(() => {
        raf = 0;
        evaluateScroll();
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    evaluateScroll();

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (raf) window.cancelAnimationFrame(raf);
    };
  }, [view]);

  useEffect(() => {
    const nav = navRef.current;
    if (!nav) return;
    const onScroll = () => {
      if (window.scrollY > 30) nav.classList.add("scrolled");
      else nav.classList.remove("scrolled");
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const totalCases = CASE_BG.length;

  useEffect(() => {
    let auto = window.setInterval(
      () => setCaseActive((a) => (a + 1) % totalCases),
      3000
    );
    const stage = caseStageRef.current;
    const pause = () => {
      window.clearInterval(auto);
    };
    const resume = () => {
      auto = window.setInterval(
        () => setCaseActive((a) => (a + 1) % totalCases),
        3000
      );
    };
    if (stage) {
      stage.addEventListener("mouseenter", pause);
      stage.addEventListener("mouseleave", resume);
    }
    return () => {
      window.clearInterval(auto);
      if (stage) {
        stage.removeEventListener("mouseenter", pause);
        stage.removeEventListener("mouseleave", resume);
      }
    };
  }, [totalCases]);

  const goCase = useCallback(
    (i) => setCaseActive((i + totalCases * 10) % totalCases),
    [totalCases]
  );

  const handleNavAnchor = useCallback((e) => {
    const href = e.currentTarget.getAttribute("href");
    if (!href || !href.startsWith("#")) return;
    e.preventDefault();
    /* 跨视图锚点：先切回 landing，再等下一帧滚到目标 */
    const scrollTo = () => {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    if (view !== "landing") {
      navigate("landing");
      window.requestAnimationFrame(() =>
        window.requestAnimationFrame(scrollTo)
      );
    } else {
      scrollTo();
    }
  }, [view, navigate]);

  const handleGoPrice = useCallback((e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    navigate("price");
    scrollPageToTop();
  }, [navigate]);

  const handleGoNews = useCallback((e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    // 预览返回后台列表，避免在 iframe 内进入公开资讯列表并发起公开请求。
    if (previewMode) {
      onPreviewClose?.();
      return;
    }
    navigate("news");
    scrollPageToTop();
  }, [previewMode, onPreviewClose, navigate]);

  /** 打开资讯详情并记录历史，view 保持 news，顶部导航（含资讯 active）不变。 */
  const handleOpenNewsDetail = useCallback((id, title) => {
    if (!id) return;
    navigate("news", id, title || "");
    scrollPageToTop();
  }, [navigate]);

  const handleBackToNewsList = useCallback(() => {
    navigate("news");
    scrollPageToTop();
  }, [navigate]);

  /**
   * 资讯切换（列表 ⇄ 详情、详情之间）渲染完成后再置顶一次。
   *
   * 点击处理函数里的置顶发生在 React 替换正文之前；iOS Safari 在随后的文档高度变化
   * （旧正文卸载 → 加载态变矮 → 新正文变高）时会丢掉这次滚动，表现为停在半路。
   * useLayoutEffect 在 DOM 提交后、浏览器绘制前执行，此时新内容已经落地，置顶不会再被打断。
   * 下一帧再检查一次：iOS 偶发在点击手势的同一任务里忽略程序化滚动，只有确实没到顶才补。
   */
  useLayoutEffect(() => {
    if (view !== "news") return undefined;
    scrollPageToTop();
    const raf = window.requestAnimationFrame(() => {
      if (window.scrollY > 0) scrollPageToTop();
    });
    return () => window.cancelAnimationFrame(raf);
  }, [view, newsDetailId]);

  const handleGoLanding = useCallback((e) => {
    if (e) e.preventDefault();
    navigate("landing");
    scrollPageToTop();
  }, [navigate]);

  const handleAppDownload = useCallback(() => {
    if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
      window.open("https://bujue.art/down_app.html");
    } else {
      setAppModalVisible(true);
    }
  }, []);

  const handleIntroDownload = useCallback(() => {
    downloadFile(OFFICIAL_SITE_INTRO_PDF_URL, "不觉bujue.art中文介绍.pdf");
  }, []);

  const handlePrivateDomainClick = useCallback((e, isSubscribe = false) => {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }
    navigateToPrivateDomain({
      platform: identifyDevicePlatform(),
      isWx: Boolean(navigator.userAgent.match(/micromessenger/i)),
      isDd: /DingTalk/.test(navigator.userAgent),
      token: getCookie("mtoken"),
      isSubscribe,
    });
  }, []);

  /** 不只看 cookie 是否存在 —— 老代码用 getCookie("mtoken") 判断登录态，
   *  但 mtoken 在 .bujue.art 下跨子域共享，访问帮助页等同域页面会把别的环境
   *  token 漏到当前环境，导致按钮误判为"已登录"。改为调 queryUserByToken
   *  二次校验：API 返回有效用户对象才算登录。 */
  const [hasAuthCookie, setHasAuthCookie] = useState(false);
  useEffect(() => {
    const token = getCookie("mtoken");
    if (!token) {
      setHasAuthCookie(false);
      return;
    }
    let cancelled = false;
    queryUserByToken(token)
      .then((res) => {
        if (cancelled) return;
        // 接口返回字符串 JSON：合法用户对象才算登录态
        let user = null;
        try {
          user = typeof res === "string" ? JSON.parse(res) : res;
        } catch (_) {
          user = null;
        }
        setHasAuthCookie(Boolean(user && (user.id || user.userId || user.uid)));
      })
      .catch(() => {
        if (!cancelled) setHasAuthCookie(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  /* 固定设计画布 + 等比缩放。按视口宽高切换设计基准：
   *   竖屏 & ≤1024 → pad 竖屏 1024 设计，zoom = innerWidth/1024（.ow-pad-port）
   *   其他 ≤1366  → pad 横屏 1366 设计，zoom = innerWidth/1366（.ow-pad-land）
   *   >1366       → web 1920 设计，zoom = innerWidth/1920
   * zoom 不产生包含块，内部 fixed 元素仍相对视口，文档高度随 zoom 自动收缩。
   *
   * 同时维护 --ow-hairline：1px 设计线应该画成「整数个设备像素」。 */
  useEffect(() => {
    const el = scaleRef.current;
    if (!el) return;
    let dprQuery = null;
    let watchedDpr = 0;
    const apply = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      /* UA 判定：'pad' 走 pad 分支并按宽高比分横竖屏；'pc' 永远 web；'phone' 理论由 DeviceRouter 拦走，兜底当 pc 处理 */
      const platform = detectDevice();
      let padPort, padLand;
      if (platform === "pad") {
        padPort = h > w;
        padLand = !padPort;
      } else {
        padPort = false;
        padLand = false;
      }
      const base = padPort ? 1024 : padLand ? 1366 : 1920;
      el.classList.toggle("ow-pad-port", padPort);
      el.classList.toggle("ow-pad-land", padLand);
      if (padPort || padLand) {
        /* pad 分支：固定画布 + zoom 缩放铺满 */
        el.style.width = base + "px";
        el.style.zoom = String(w / base);
        /* 设计坐标系下的视口高度。zoom 会把 vh 二次缩放，CSS 里直接用 100vh 会偏小，
         * 这里换算成设计 px 供 Pad 竖屏把页面撑满一屏使用。 */
        el.style.setProperty("--ow-design-vh", `${h / (w / base)}px`);
      } else {
        /* web 分支：放开浏览器缩放与窗口宽，由 CSS 响应式承接 */
        el.style.width = "";
        el.style.zoom = "";
        el.style.removeProperty("--ow-design-vh");
      }

      /* 1px 设计线（分页上 / 下细线、中间竖线）换算成整数个设备像素，写到 --ow-hairline。
       *
       * 原因：浏览器缩放 125% / 150% 时 devicePixelRatio 是 1.25 / 1.5，1 CSS px 变成
       * 1.25 / 1.5 个设备像素。Chromium 对纯色矩形填充是按设备像素吸附绘制的（实测无
       * 抗锯齿混合），边缘取整后同一条 1px 线在不同纵向位置上会分别落成 1 行或 2 行 ——
       * 于是同一个页面里上细线、下细线时粗时细，竖线在 150% 下变成 2 列。
       * 线的纵向位置是整数 CSS px 累加出来的，乘以小数 DPR 后小数部分各不相同，
       * 所以无法靠「对齐布局」解决，只能改厚度。
       *
       * 做法：取「不超过 1px 的整数设备像素」再换算回设计 px：
       *   scale = zoom × dpr（zoom 是 pad 分支的整页缩放，web 分支为 1）
       *   devicePx = max(1, floor(scale)) → 100% / 200% / 300% 下保持 1px 原样，
       *     125% / 150% / 175% 下取 1 个设备像素（0.8 / 0.67 / 0.57px），
       *     吸附后恒为 1 行，不再时而 2 行。
       * 布局长度按 1/64 px 量化，devicePx / scale 也是按最近 1/64 落地的，
       * 所以极少数落点上仍可能差 1 行（125% 下实测 128 个位置全部 1 行）。
       */
      const dpr = window.devicePixelRatio || 1;
      const zoom = padPort || padLand ? w / base : 1;
      const scale = zoom * dpr;
      const devicePx = Math.max(1, Math.floor(scale + 1e-6));
      document.documentElement.style.setProperty(
        "--ow-hairline",
        `${+(devicePx / scale).toFixed(5)}px`
      );

      watchDpr();
    };

    /* 浏览器缩放 / 跨不同缩放比的显示器会改 devicePixelRatio，resize 不一定触发，
     * 再用 matchMedia 的 resolution 变化兜一层（dpr 变了要重新挂一个新的 query）。 */
    const watchDpr = () => {
      const dpr = window.devicePixelRatio || 1;
      if (dpr === watchedDpr) return;
      watchedDpr = dpr;
      if (dprQuery) {
        if (dprQuery.removeEventListener) dprQuery.removeEventListener("change", apply);
        else if (dprQuery.removeListener) dprQuery.removeListener(apply);
      }
      dprQuery = window.matchMedia(`(resolution: ${dpr}dppx)`);
      if (dprQuery.addEventListener) dprQuery.addEventListener("change", apply);
      else if (dprQuery.addListener) dprQuery.addListener(apply);
    };

    apply();
    window.addEventListener("resize", apply);
    return () => {
      window.removeEventListener("resize", apply);
      if (dprQuery) {
        if (dprQuery.removeEventListener) dprQuery.removeEventListener("change", apply);
        else if (dprQuery.removeListener) dprQuery.removeListener(apply);
        dprQuery = null;
      }
      document.documentElement.style.removeProperty("--ow-hairline");
    };
  }, []);

  return (
    <div className="ow-scale-root" ref={scaleRef}>
      <div
        ref={rootRef}
        className={
          /* 后台资讯预览：nav-links / footer 只作静态还原，交互由 landing.less 统一关掉 */
          "page-container" +
          (view === "news" ? " page-container--news" : "") +
          (previewMode ? " page-container--preview" : "")
        }
      >
        <nav ref={navRef} className="nav" id="nav">
          <div className="nav-inner">
            <a href="#" className="brand" onClick={handleGoLanding}>
              <img
                className="brand-logo"
                src={assetUrl(imgBujueLogo)}
                alt="不觉"
              />
            </a>
            <ul className="nav-links">
              <li className="nav-has-dropdown">
                <span
                  className={`nav-link-btn${view === "landing" ? " is-active" : ""}`}
                  role="button"
                  tabIndex={0}
                  onClick={handleGoLanding}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") handleGoLanding(e);
                  }}
                >
                  产品
                </span>
                <ul className="nav-dropdown">
                  <li><a href="#product-create-web" onClick={handleNavAnchor}>网站搭建</a></li>
                  <li><a href="#product-portfolio" onClick={handleNavAnchor}>作品集/产品册</a></li>
                  <li><a href="#product-partners" onClick={handleNavAnchor}>商业圈子</a></li>
                  <li><a href="#product-mini-program" onClick={handleNavAnchor}>微信小程序</a></li>
                </ul>
              </li>
              <li>
                <a href="#cases" onClick={handleNavAnchor}>案例</a>
              </li>
              {newsEntryVisible ? (
                <li className="nav-li--news">
                  <a
                    href="?view=news"
                    className={view === "news" ? "is-active" : ""}
                    onClick={handleGoNews}
                  >
                    资讯
                  </a>
                </li>
              ) : null}
              <li className="nav-li--price">
                <a
                  href="#"
                  className={view === "price" ? "is-active" : ""}
                  onClick={handleGoPrice}
                >
                  价格
                </a>
              </li>
              <li>
                <a
                  href={OFFICIAL_SITE_INSTRUCTIONS_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  帮助
                </a>
              </li>
            </ul>
            <div className="nav-cta">
              {!previewMode ? (
                hasAuthCookie ? (
                  <a
                    href="#"
                    className="btn btn-dark"
                    onClick={handlePrivateDomainClick}
                  >
                    进入私域
                  </a>
                ) : (
                  <>
                    <a href="/login.html" className="btn btn-ghost">
                      登录
                    </a>
                    <a href="/login.html" className="btn btn-dark">
                      免费注册
                    </a>
                  </>
                )
              ) : null}
              {previewMode ? (
                <button
                  type="button"
                  className="nav-preview-close"
                  aria-label="关闭预览"
                  onClick={onPreviewClose}
                >
                  <Iconfont type="icon-a-guanbixi" />
                </button>
              ) : null}
            </div>
          </div>
        </nav>

        {view === "price" && (
          <PricePage
            onContact={() => setContactVisible(true)}
            onSubscribe={(e) => handlePrivateDomainClick(e, true)}
          />
        )}

        {/* 资讯：列表 / 详情共用 view=news，nav / footer 常驻 */}
        {view === "news" &&
          (newsDetailId ? (
            <NewsDetail
              id={newsDetailId}
              title={newsDetailTitle}
              onBack={previewMode ? onPreviewClose : handleBackToNewsList}
              onOpenDetail={handleOpenNewsDetail}
              previewArticle={previewDetail.article}
              previewLoading={previewDetail.loading}
              previewError={previewDetail.error}
              previewMode={previewMode}
            />
          ) : (
            <NewsPage onOpenDetail={handleOpenNewsDetail} />
          ))}

        {view === "landing" && (
        <>
        <header className="hero">
          <div className="hero-blob b1" aria-hidden="true" />
          <div className="hero-blob b2" aria-hidden="true" />
          <div className="hero-blob b3" aria-hidden="true" />
          <div className="hero-title">
            {/* <span className="word w1">私域圈新商业工具</span> */}
            <span className="word w2">让每一个创作者、每一个企业</span>
            <br />
            <span className="word w3">都有自己的品牌阵地</span>
          </div>
          <div className="hero-tag-container">
            <div className="hero-tag">
              零代码搭建品牌网站（个人/企业）
            </div>
            <div className="hero-tag">
              快速生成高定作品集/产品册
            </div>
            <div className="hero-tag">
              私域圈新商业工具
            </div>
          </div>
          <div className="hero-cta">
            <a
              href="#"
              className="btn btn-primary"
              onClick={handlePrivateDomainClick}
            >
              立即使用
            </a>
            <a
              href="https://v.wjx.cn/vm/PD6aaEY.aspx#"
              className="btn btn-primary btn-primary--white"
              target="_blank"
              rel="noopener noreferrer"
            >
              联系我们
            </a>
          </div>

          <div className="hero-stage" id="heroStage">
            <div className="hero-stage-canvas">
              <div className="hero-stage-panel" aria-hidden="true" />
              <div
                className="hero-pop pop-tl"
                style={bgImageStyle(imgHeroCard1)}
              />
              <div
                className="hero-pop pop-tr"
                style={bgImageStyle(imgHeroCard2)}
              />
              <div
                className="hero-pop pop-bl"
                style={bgImageStyle(imgHeroCard4)}
              />
              <div
                className="hero-pop pop-br"
                style={bgImageStyle(imgHeroCard3)}
              />
              <div className="hero-ipad">
                <div
                  className="hero-ipad-screen"
                  style={bgImageStyle(imgHeroScreen)}
                />
              </div>
            </div>
          </div>
        </header>

        <section className="service" id="service">
          <div className="sec-head reveal sec-head--nowrap">
            <span className="eyebrow">不觉功能</span>
            <div className="sec-title">不觉做什么</div>
            <p>无需代码，免费注册，人人都能快速拥有专业的在线展示与私域营销工具，专注服务于设计、家居建材及泛美学行业</p>
          </div>

          <div className="service-row" id="product-create-web">
            <div className="service-text reveal">
              <div className="service-icon-row">
                <span className="service-icon">
                  <Iconfont type="icon-a-diqiuxi" />
                </span>
                品牌官网
              </div>
              <h3>
                零代码搭建品牌（个人/企业）网站
              </h3>
              <p>
                无需一行代码，个性化搭建品牌官网
              </p>
              <p>
                视觉美学精彩呈现，支持多语言助力全球出海
              </p>
              <p>
                电脑与手机自适应，快速上线品牌官网
              </p>
              <div className="chip-row">
                <span className="chip">零代码</span>
                <span className="chip">美学视觉</span>
                <span className="chip">多语言支持</span>
                <span className="chip">电脑 / 移动双端自适应</span>
              </div>
            </div>
            <div className="service-media service-media--wad reveal delay-1">
              <div className="service-create-web">
                <img
                  className="service-create-web__img"
                  src={assetUrl(imgCreateWeb)}
                  alt=""
                />
                <div className="service-create-web__copy">
                  <p className="service-create-web__est">
                    <span
                      className="service-create-web__rule service-create-web__rule--before-est"
                      aria-hidden="true"
                    />
                    EST. CHINA · GLOBAL
                  </p>
                  <div className="service-create-web__content">
                    <p className="service-create-web__intro">— INTRODUCTION</p>
                    <h4 className="service-create-web__wad">WAD</h4>
                    <p className="service-create-web__sub-zh">
                      中国首家豪宅设计建造顾问企业
                    </p>
                    <p className="service-create-web__sub-en">
                      Consulting firm for the design and construction of private
                      mansions
                    </p>
                  </div>
                  <div className="service-create-web__scroll" aria-hidden="true">
                    <span>SCROLL</span>
                    <span className="service-create-web__rule service-create-web__rule--after-scroll" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="service-row reverse" id="product-portfolio">
            <div
              ref={generatedPortfolioRef}
              className="service-media service-media--generated-portfolio reveal"
            >
              <div className="generated-portfolio-slides">
                {GENERATED_PORTFOLIO_IMGS.map((img, i) => {
                  const active = genStep >= 3 ? 2 : genStep;
                  const cls =
                    i < active
                      ? "is-prev"
                      : i === active
                        ? "is-active"
                        : "is-next";
                  return (
                    <img
                      key={i}
                      className={`generated-portfolio-slides__img ${cls}`}
                      src={assetUrl(img)}
                      alt=""
                    />
                  );
                })}
                {(() => {
                  const genActive = genStep >= 3 ? 2 : genStep;
                  const pulseCls = portfolioClickPulse ? " is-pulse" : "";
                  const focusInner = (
                    <>
                      <span
                        className="generated-portfolio-clickfx__halo"
                        aria-hidden="true"
                      />
                      <span
                        className="generated-portfolio-clickfx__core"
                        aria-hidden="true"
                      />
                      <span
                        className="generated-portfolio-clickfx__pulse-ring"
                        aria-hidden="true"
                        onAnimationEnd={handlePortfolioPulseEnd}
                      />
                      <button
                        type="button"
                        className="generated-portfolio-clickfx__hit"
                        aria-label={
                          genActive === 0
                            ? "点击顶栏示意区域"
                            : "点击「产品」示意区域"
                        }
                        onClick={handlePortfolioEndClick}
                      />
                    </>
                  );
                  if (genActive === 0) {
                    return (
                      <div
                        className={`generated-portfolio-clickfx generated-portfolio-clickfx--generated1${pulseCls} portfolio-slide0-cursor-anim`}
                      >
                        <div className="generated-portfolio-clickfx__travel-layer">
                          <div className="generated-portfolio-clickfx__cursor-pin">
                            <span
                              className="generated-portfolio-clickfx__cursor-wrap"
                              aria-hidden="true"
                            >
                              <span
                                className="generated-portfolio-clickfx__cursor"
                                style={bgImageStyle(imgDemoCursor)}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="generated-portfolio-clickfx__focus generated-portfolio-clickfx__focus--slide0-end">
                          {focusInner}
                        </div>
                      </div>
                    );
                  }
                  if (genActive === 1) {
                    return (
                      <div
                        className={`generated-portfolio-clickfx generated-portfolio-clickfx--generated2${pulseCls} portfolio-slide1-cursor-anim`}
                      >
                        <div className="generated-portfolio-clickfx__travel-layer">
                          <div className="generated-portfolio-clickfx__cursor-pin generated-portfolio-clickfx__cursor-pin--slide1">
                            <span
                              className="generated-portfolio-clickfx__cursor-wrap"
                              aria-hidden="true"
                            >
                              <span
                                className="generated-portfolio-clickfx__cursor"
                                style={bgImageStyle(imgDemoCursor)}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="generated-portfolio-clickfx__focus generated-portfolio-clickfx__focus--slide1-end">
                          {focusInner}
                        </div>
                      </div>
                    );
                  }
                  /* 第三张图：shubiao 停在第二张结束的位置（clickfx），无光圈/点击区 */
                  if (genActive === 2) {
                    return (
                      <div className="generated-portfolio-clickfx generated-portfolio-clickfx--generated3">
                        <div className="generated-portfolio-clickfx__travel-layer">
                          <span
                            className="generated-portfolio-clickfx__cursor-wrap generated-portfolio-clickfx__cursor-wrap--gp3-fixed"
                            aria-hidden="true"
                          >
                            <span
                              className="generated-portfolio-clickfx__cursor"
                              style={bgImageStyle(imgDemoCursor)}
                            />
                          </span>
                        </div>
                      </div>
                    );
                  }
                  return null;
                })()}
              </div>
            </div>
            <div className="service-text reveal delay-1">
              <div className="service-icon-row">
                <span className="service-icon">
                  <Iconfont type="icon-a-tupianxi" />
                </span>
                作品集 / 产品册
              </div>
              <h3>
                生成高定作品集/产品册
              </h3>
              <p>
                上传即拥有数据化、结构化的美学作品/产品库
              </p>
              <p>
                链接可分享，避免图册的繁杂制作和庞大文件的空间占据
              </p>
              <p>
                无需手动排版，自动生成美学版式，可自由分类
              </p>
              <p>
                自助设置分享内容，分享全程可追踪
              </p>
              <p>
                多语言支持，自动适配电脑、Pad、手机、大屏等端口
              </p>
              <div className="chip-row">
                <span className="chip">链接分享</span>
                <span className="chip">精美页面</span>
                <span className="chip">权限控制</span>
                <span className="chip">自动排版</span>
              </div>
            </div>
          </div>

          <div className="service-row" id="product-partners">
            <div className="service-text reveal">
              <div className="service-icon-row">
                <span className="service-icon">
                  <Iconfont type="icon-a-chengyuanxi" />
                </span>
                商业圈子
              </div>
              <h3>商业圈 - 商业圈子</h3>
              <p>
              私域间引流：可与自己建联的商业圈子，相互实现品牌、产品曝光
              </p>
              <div className="chip-row">
                <span className="chip">私域引流</span>
                <span className="chip">品牌曝光</span>
              </div>
            </div>
            <div
              ref={privateSphereRef}
              className="service-media service-media--private-sphere reveal delay-1"
            >
              <div className="generated-portfolio-slides generated-portfolio-slides--private-sphere">
                {PRIVATE_SPHERE_IMGS.map((img, i) => {
                  const active =
                    psStep >= PRIVATE_SPHERE_MAX_STEP ? 1 : psStep;
                  const cls =
                    i < active
                      ? "is-prev"
                      : i === active
                        ? "is-active"
                        : "is-next";
                  return (
                    <img
                      key={i}
                      className={`generated-portfolio-slides__img ${cls}`}
                      src={assetUrl(img)}
                      alt=""
                    />
                  );
                })}
                {(() => {
                  const psFxActive = psStep === 0 ? 0 : 1;
                  const pulseCls = privateSpherePulse ? " is-pulse" : "";
                  const focusInner = (
                    <>
                      <span
                        className="generated-portfolio-clickfx__halo"
                        aria-hidden="true"
                      />
                      <span
                        className="generated-portfolio-clickfx__core"
                        aria-hidden="true"
                      />
                      <span
                        className="generated-portfolio-clickfx__pulse-ring"
                        aria-hidden="true"
                        onAnimationEnd={handlePrivateSpherePulseEnd}
                      />
                      <button
                        type="button"
                        className="generated-portfolio-clickfx__hit"
                        aria-label={
                          psFxActive === 0
                            ? "点击商业圈子示意区域"
                            : "点击伙伴网络示意区域"
                        }
                        onClick={handlePrivateSphereHitClick}
                      />
                    </>
                  );
                  if (psFxActive === 0) {
                    return (
                      <div
                        className={`generated-portfolio-clickfx generated-portfolio-clickfx--generated1${pulseCls} portfolio-slide0-cursor-anim`}
                      >
                        <div className="generated-portfolio-clickfx__travel-layer">
                          <div className="generated-portfolio-clickfx__cursor-pin">
                            <span
                              className="generated-portfolio-clickfx__cursor-wrap"
                              aria-hidden="true"
                            >
                              <span
                                className="generated-portfolio-clickfx__cursor"
                                style={bgImageStyle(imgDemoCursor)}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="generated-portfolio-clickfx__focus generated-portfolio-clickfx__focus--slide0-end">
                          {focusInner}
                        </div>
                      </div>
                    );
                  }
                  /* private_2：仅光标停在稿面箭头尖端，无光晕/涟漪/命中区 */
                  if (psFxActive === 1) {
                    return (
                      <div className="generated-portfolio-clickfx generated-portfolio-clickfx--private-slide2">
                        <div className="generated-portfolio-clickfx__travel-layer">
                          <span
                            className="generated-portfolio-clickfx__cursor-wrap generated-portfolio-clickfx__cursor-wrap--private-fixed"
                            aria-hidden="true"
                          >
                            <span
                              className="generated-portfolio-clickfx__cursor"
                              style={bgImageStyle(imgDemoCursor)}
                            />
                          </span>
                        </div>
                      </div>
                    );
                  }
                  return null;
                })()}
              </div>
            </div>
          </div>

          <div className="service-row reverse" id="product-mini-program">
            <div
              ref={miniProgramMediaRef}
              className={`service-media service-media--mini-program reveal${miniProgramRevealIn ? " in" : ""
                }${miniProgramStage === 1 ? " mini-program-stage--alt" : ""}`}
            >
              <div className="phone-mock">
                <div
                  className="phone-mock__bg"
                  style={bgImageStyle(imgMiniProgramBg)}
                  aria-hidden
                />
                <div className="phone-mock__overlay" aria-hidden />
                <div className="phone-mock__devices" aria-hidden="true">
                  <div className="phone-device phone-device--left">
                    <div className="phone-screen phone-screen--xcx">
                      <div className="phone-screen__xcx-crop">
                        <img
                          className="phone-screen__xcx-img"
                          src={assetUrl(imgXiaochengxu)}
                          alt=""
                          draggable={false}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="phone-device phone-device--right">
                    <div className="phone-screen phone-screen--xcx">
                      <div className="phone-screen__xcx-crop">
                        <img
                          className="phone-screen__xcx-img"
                          src={assetUrl(imgXiaochengxu)}
                          alt=""
                          draggable={false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="service-text reveal delay-1">
              <div className="service-icon-row">
                <span className="service-icon">
                  <img src={assetUrl(IMG.serviceMiniProgram)} alt="" />
                </span>
                微信小程序
              </div>
              <h3>快速生成品牌微信小程序</h3>
              <p>
                无需代码，为你快速生成专属品牌、精美视觉的微信小程序；一步跨越技术门槛，轻量抢占移动端入口。
              </p>
              <div className="chip-row">
                <span className="chip">无需代码</span>
                <span className="chip">品牌小程序</span>
                <span className="chip">轻量化引流</span>
              </div>
            </div>
          </div>
        </section>

        <section className="sec cases" id="cases">
          <div className="sec-head reveal">
            <span className="eyebrow">服务案例</span>
            <div className="sec-title">案例展示</div>
            {/* <a
              className="cases__more"
              href="#"
              onClick={(e) => e.preventDefault()}
            >
              查看更多
              <img src={IMG.arrowRightPC} className="cases__more-arrow" alt="" />
            </a> */}
          </div>

          <div className="case-stage" ref={caseStageRef}>
            <button
              type="button"
              className="case-arrow prev"
              aria-label="上一个"
              onClick={() => goCase(caseActive - 1)}
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
            <button
              type="button"
              className="case-arrow next"
              aria-label="下一个"
              onClick={() => goCase(caseActive + 1)}
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path d="M9 6l6 6-6 6" />
              </svg>
            </button>
            <div className="case-track" id="caseTrack">
              {CASE_BG.map((src, i) => (
                <div
                  key={i}
                  role="presentation"
                  className={caseSlideClass(i, caseActive, totalCases)}
                  data-idx={i}
                  onClick={() => {
                    if (i !== caseActive) goCase(i);
                  }}
                >
                  <div
                    className="inner"
                    style={bgImageStyle(src)}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="case-dots" id="caseDots">
            {CASE_BG.map((_, i) => (
              <button
                key={i}
                type="button"
                className={i === caseActive ? "active" : ""}
                data-i={i}
                onClick={() => goCase(i)}
              />
            ))}
          </div>
        </section>

        <section className="logos">
          <div className="logo-track" id="logoTrack">
            {[...SCROLL_BRAND_IMAGES, ...SCROLL_BRAND_IMAGES].map((src, i) => (
              <div key={`scroll-brand-${i}`} className="logo-item logo-item--brand">
                <img
                  src={assetUrl(src)}
                  alt=""
                  draggable={false}
                />
              </div>
            ))}
          </div>
        </section>

        <section className="sec solutions">
          <div className="sec-head reveal">
            <span className="eyebrow">应用场景</span>
            <div className="sec-title">不觉怎么用</div>
            <p>3500+团队/企业已将不觉融入日常办公，让每一次分享、每一次链接都产生价值</p>
          </div>
          <div className="solution-grid">
            <div className="solution-card reveal">
              <div className="solution-thumb">
                <div className="bg" style={bgImageStyle(imgSolution2)} />
                <button
                  type="button"
                  className="play-btn"
                  aria-label="播放视频"
                  onClick={() => setVideoUrl(SOLUTION_VIDEOS[0])}
                >
                  <img src={IMG.play} alt="" />
                </button>
              </div>
              <div className="solution-title">设计师/设计公司/全案公司-应用场景</div>
            </div>
            <div className="solution-card reveal">
              <div className="solution-thumb">
                <div className="bg" style={bgImageStyle(imgSolution1)} />
                <button
                  type="button"
                  className="play-btn"
                  aria-label="播放视频"
                  onClick={() => setVideoUrl(SOLUTION_VIDEOS[1])}
                >
                  <img src={IMG.play} alt="" />
                </button>
              </div>
              <div className="solution-title">组织机构/学会/协会-应用场景</div>
            </div>
            <div className="solution-card reveal delay-1">
              <div className="solution-thumb">
                <div className="bg" style={bgImageStyle(imgSolution2)} />
                <button
                  type="button"
                  className="play-btn"
                  aria-label="播放视频"
                  onClick={() => setVideoUrl(SOLUTION_VIDEOS[2])}
                >
                  <img src={IMG.play} alt="" />
                </button>
              </div>
              <div className="solution-title">材料品牌/经销商/材料集合商-应用场景</div>
            </div>
          </div>
          <div className="solutions-cta">
            <a
              href="https://v.wjx.cn/vm/PD6aaEY.aspx#"
              className="solutions-cta__btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              联系我们
            </a>
          </div>
        </section>
        </>
        )}

        <footer className="footer">
          <div className="footer-inner">
            <div className="footer-brand">
              <a href="#" className="brand">
                <img
                  className="brand-logo"
                  src={assetUrl(imgBujueLogoWhite)}
                  alt="不觉"
                />
              </a>
              <div className="social">
                <div className={`social-item${openSocialIdx === 0 ? " is-open" : ""}`}>
                  <a
                    href="#"
                    aria-label="WeChat"
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenSocialIdx(openSocialIdx === 0 ? null : 0);
                    }}
                  >
                    <img src={assetUrl(IMG.socialWechat)} alt="WeChat" />
                  </a>
                  <div className="social-qr-popup">
                    <img src={assetUrl(IMG.gongzhonghaoQr)} alt="微信公众号二维码" />
                  </div>
                </div>
                <div className={`social-item${openSocialIdx === 1 ? " is-open" : ""}`}>
                  <a
                    href="#"
                    aria-label="Xiaohongshu"
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenSocialIdx(openSocialIdx === 1 ? null : 1);
                    }}
                  >
                    <img src={assetUrl(IMG.socialXiaohongshu)} alt="Xiaohongshu" />
                  </a>
                  <div className="social-qr-popup">
                    <img src={assetUrl(IMG.xiaohongshuQr)} alt="小红书二维码" />
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-cols">
              <div className="footer-col">
                <h4>友情链接</h4>
                <ul>
                  <li>
                    <a
                      href="https://www.shejidedao.com/?a=bujue"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      设计得到
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://panbadou.panzitech.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      项目管理工具
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://bujue.art/material_square.html"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      家具建材广场
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.archebase.co.jp/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      ARCHBASE建材供应链
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-col">
                <h4
                  className="footer-col__h4--clickable"
                  onClick={handleGoLanding}
                >
                  不觉功能
                </h4>
                <ul>
                  <li>
                    <a href="#product-create-web" onClick={handleNavAnchor}>网站搭建</a>
                  </li>
                  <li>
                    <a href="#product-portfolio" onClick={handleNavAnchor}>作品集/产品册</a>
                  </li>
                  <li>
                    <a href="#product-partners" onClick={handleNavAnchor}>商业圈子</a>
                  </li>
                  <li>
                    <a href="#product-mini-program" onClick={handleNavAnchor}>微信小程序</a>
                  </li>
                </ul>
              </div>
              <div className="footer-col">
                <h4>支持帮助</h4>
                <ul>
                  <li>
                    <a
                      href={OFFICIAL_SITE_INSTRUCTIONS_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      操作说明
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => { e.preventDefault(); handleAppDownload(); }}
                    >
                      APP下载
                    </a>
                  </li>
                  <li>
                    <a
                      href={`/agreement.html?fileUrl=${protocol.privacy}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      隐私政策
                    </a>
                  </li>
                  <li>
                    <a
                      href={`/agreement.html?fileUrl=${protocol.teamservice}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      服务条款
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-col">
                <h4>关于我们</h4>
                <ul>
                  <li>
                    <a
                      href="https://mp.weixin.qq.com/s?__biz=Mzk0ODYxNTM4Ng==&mid=2247483956&idx=1&sn=fc2eb3617ff02514fdeaa33f21b08542&chksm=c291a1df30a5152e1de626808116c5ac2e8ef2effce9339ae2e73207c2f4d329c42723400c98&mpshare=1&scene=1&srcid=0717gAZlU6igrtnd9MBiZq6X&sharer_shareinfo=f2cc040ae2937be0aadb2f70d0ab82ba&sharer_shareinfo_first=f2cc040ae2937be0aadb2f70d0ab82ba#rd"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      关于我们
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => { e.preventDefault(); handleIntroDownload(); }}
                    >
                      下载介绍
                    </a>
                  </li>

                </ul>
              </div>
              <div className="footer-col">
                <h4>联系我们</h4>
                <ul>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => { e.preventDefault(); setContactVisible(true); }}
                    >
                      联系客服
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://v.wjx.cn/vm/PD6aaEY.aspx#"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      企业咨询
                    </a>
                  </li>
                  <li>
                    <a className="footer-col__static">
                      邮箱：bujuekefu@bujue.art
                    </a>
                  </li>
                  <li>
                    <a className="footer-col__static">
                      电话：400-189-9196
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <span>© 2026 杭州不觉科技有限公司 </span>
            <span>
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="noopener noreferrer"
              >
                浙ICP备17033477号-5
              </a>
            </span>
          </div>
        </footer>

      </div>

      {contactVisible && (
        <div className="ow-modal-overlay" onClick={() => setContactVisible(false)}>
          <div className="ow-modal" onClick={(e) => e.stopPropagation()}>
            <button className="ow-modal-close" type="button" onClick={() => setContactVisible(false)}>×</button>
            <h3 className="ow-modal-title">联系我们</h3>
            <div className="ow-modal-body">
              <img src={assetUrl(IMG.kefuQr)} className="ow-modal-qr" alt="微信客服二维码" />
              <p className="ow-modal-text">扫码添加客服微信</p>
              <p className="ow-modal-sub">你也可以拨打400-189-9196</p>
            </div>
          </div>
        </div>
      )}

      {appModalVisible && (
        <div className="ow-modal-overlay" onClick={() => setAppModalVisible(false)}>
          <div className="ow-modal" onClick={(e) => e.stopPropagation()}>
            <button className="ow-modal-close" type="button" onClick={() => setAppModalVisible(false)}>×</button>
            <h3 className="ow-modal-title">获取APP</h3>
            <div className="ow-modal-body">
              <QRCodeCanvas value={getUrl() + "down_app.html"} size={170} fgColor="#000000" />
              <p className="ow-modal-text">扫一扫下载APP</p>
            </div>
          </div>
        </div>
      )}

      {videoUrl && (
        <div className="ow-video-overlay" onClick={() => setVideoUrl(null)}>
          <div className="ow-video-modal" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="ow-video-close"
              onClick={() => setVideoUrl(null)}
            >
              ×
            </button>
            {!videoReady && (
              <video
                className="ow-video-cover"
                src={`${videoUrl}#t=0.1`}
                preload="auto"
                muted
                playsInline
                aria-hidden="true"
              />
            )}
            <ReactPlayer
              url={videoUrl}
              playing
              controls
              width="100%"
              height="100%"
              className="ow-video-iframe"
              onStart={() => setVideoReady(true)}
            />
          </div>
        </div>
      )}
    </div>
  );
}
